import { useEffect, useState } from "react";
import { Vote, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "@/components/ui/sonner";

function getVoterId() {
  let id = localStorage.getItem("emisphere_voter_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("emisphere_voter_id", id);
  }
  return id;
}

export default function CommunityPoll() {
  const [data, setData] = useState(null);
  const [voting, setVoting] = useState(false);

  const load = () => api.get(`/polls/active?voter_id=${getVoterId()}`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!data || !data.poll) return null;
  const { poll, counts, total, my_vote } = data;
  const hasVoted = my_vote !== null && my_vote !== undefined;

  const vote = async (i) => {
    setVoting(true);
    try {
      await api.post("/polls/vote", { poll_id: poll.id, option_index: i, voter_id: getVoterId() });
      load();
    } catch {
      toast.error("Vote impossible pour le moment — réessayez dans un instant");
    } finally {
      setVoting(false);
    }
  };

  return (
    <div className="card-tactical glow-orange mx-auto max-w-2xl p-6 sm:p-8" data-testid="community-poll">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-orange-500">
        <Vote className="h-4 w-4" /> Sondage
      </p>
      <h3 className="mt-3 text-xl font-extrabold uppercase tracking-tight sm:text-2xl" data-testid="poll-question">
        {poll.question}
      </h3>

      {!hasVoted ? (
        <div className="mt-5 grid gap-3">
          {poll.options.map((opt, i) => (
            <button key={i} onClick={() => vote(i)} disabled={voting} data-testid={`poll-option-${i}`}
              className="flex items-center gap-3 rounded-xl border border-orange-500/30 bg-[#060B18] px-4 py-3 text-left text-sm font-semibold text-white transition-all hover:scale-[1.01] hover:border-orange-500 hover:bg-orange-500/10 disabled:opacity-50">
              {opt.image_url && (
                <img src={opt.image_url} alt="" loading="lazy" data-testid={`poll-option-img-${i}`}
                  className="h-14 w-14 shrink-0 rounded-lg border border-orange-500/20 object-cover" />
              )}
              {opt.label}
            </button>
          ))}
          <p className="text-xs text-slate-500">Un vote par visiteur — résultats affichés après votre vote.</p>
        </div>
      ) : (
        <div className="mt-5 grid gap-3" data-testid="poll-results">
          {poll.options.map((opt, i) => {
            const pct = total > 0 ? Math.round(((counts[i] || 0) / total) * 100) : 0;
            const mine = my_vote === i;
            return (
              <div key={i} data-testid={`poll-result-${i}`}
                className={`relative overflow-hidden rounded-xl border px-4 py-3 ${mine ? "border-orange-500" : "border-slate-700"}`}>
                <div className="absolute inset-y-0 left-0 bg-orange-500/20 transition-all duration-700" style={{ width: `${pct}%` }} />
                <div className="relative flex items-center justify-between gap-3">
                  <span className="flex items-center gap-2 text-sm font-semibold text-white">
                    {opt.image_url && (
                      <img src={opt.image_url} alt="" loading="lazy"
                        className="h-10 w-10 shrink-0 rounded-lg border border-orange-500/20 object-cover" />
                    )}
                    {mine && <CheckCircle2 className="h-4 w-4 text-orange-400" />}
                    {opt.label}
                  </span>
                  <span className="text-sm font-bold text-orange-400">{pct}%</span>
                </div>
              </div>
            );
          })}
          <p className="text-xs text-slate-500" data-testid="poll-total">
            Merci pour votre vote ! {total} vote{total > 1 ? "s" : ""} au total.
          </p>
        </div>
      )}
    </div>
  );
}
